import {
  Form,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { FormField } from "@/components/ui/form/FormField";
import { Input } from "@/components/ui/input";
import type { UseFormReturn } from "react-hook-form";
import { AlertMessage } from "@/components/ui/AlertMessage";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { t } from "i18next";
import type { EmailChangeSchemaType } from "@/schemas/emailChange.schema";

interface Props {
  onSubmit: (data: EmailChangeSchemaType) => void;
  form: UseFormReturn<EmailChangeSchemaType>;
  isSubmitting: boolean;
}

export const EmailChangeForm = (props: Props): JSX.Element => {
  return (
    <Form {...props.form}>
      <form
        className="w-full flex flex-col"
        onSubmit={props.form.handleSubmit(props.onSubmit)}
      >
        <div className="space-y-4">
          <div className="flex flex-col gap-4">
            <FormField
              control={props.form.control}
              name="newEmail"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>
                    {t("settings.account.changeEmailForm.newEmailLabel")}
                  </FormLabel>
                  <FormControl>
                    <Input type="email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={props.form.control}
              name="confirmNewEmail"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>
                    {t("settings.account.changeEmailForm.confirmNewEmailLabel")}
                  </FormLabel>
                  <FormControl>
                    <Input type="email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          {props.form.formState.errors.root?.message && (
            <AlertMessage
              description={props.form.formState.errors.root.message}
              title="Error"
              variant="destructive"
            />
          )}
          <div className="flex justify-end">
            <Button disabled={props.isSubmitting} type="submit">
              {props.isSubmitting && <LoadingSpinner />}
              {t("settings.account.changeEmailForm.submitButton")}
            </Button>
          </div>
        </div>
      </form>
    </Form>
  );
};
